<template>
  <!-- 综合管理-社交圈管理 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permissionList.addBtn"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog('add')"
        >
          新增
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.viewBtn"
          size="small"
          type="text"
          @click="openDialog('view', row)"
        >
          查看
        </el-button>
        <el-button
          v-if="permissionList.editBtn && row.publishStatus == 0 && row.userType == 1"
          size="small"
          type="text"
          @click="openDialog('edit', row)"
        >
          编辑
        </el-button>
        <el-button
          v-if="permissionList.releaseBtn && row.publishStatus == 0"
          size="small"
          type="text"
          @click="showConfirm('release', row)"
        >
          发布
        </el-button>
        <el-button
          v-if="permissionList.delBtn && row.publishStatus == 0"
          size="small"
          type="text"
          @click="showConfirm('del', row)"
        >
          删除
        </el-button>
        <el-button
          v-if="permissionList.visibleBtn && row.publishStatus == 1 && row.showFlag == 0"
          size="small"
          type="text"
          @click="showConfirm('visible', row)"
        >
          显示
        </el-button>
        <el-button
          v-if="permissionList.hiddenBtn && row.publishStatus == 1 && row.showFlag == 1"
          size="small"
          type="text"
          @click="showConfirm('hidden', row)"
        >
          不显示
        </el-button>
        <el-button
          v-if="permissionList.replyBtn && row.publishStatus == 1 && row.showFlag == 1"
          size="small"
          type="text"
          @click="openDialog('reply', row)"
        >
          回复
        </el-button>
      </template>
      <template slot="dateRangeSearch">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 100%"
        >
        </el-date-picker>
      </template>
      <template slot-scope="{ row }" slot="showFlag">
        <span>{{ row.publishStatus == 0 ? '' : row.showFlag == 1 ? '显示' : '不显示' }}</span>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      :title="dialogTitle"
      width="60%"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <Reply
        v-if="isDialogShow && dialogType == 'reply'"
        :rowData="rowData"
        :projectId="searchForm.projectId"
        @close="closeDialog"
      ></Reply>
      <Form
        v-else-if="isDialogShow"
        :dialogType="dialogType"
        :circleId="rowData.id"
        :projectId="searchForm.projectId"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></Form>
    </el-dialog>
  </basic-container>
</template>

<script>
import Form from './circle-form';
import Reply from './circle-reply';
import { mapGetters } from 'vuex';
import { getProjectListApi } from '@/api/call-system/index';
import { getPageListApi, delApi, releaseApi, visibleApi } from '@/api/general-manage/social-circle';

export default {
  components: {
    Form,
    Reply,
  },
  data() {
    return {
      oldProjectId: '', // 旧项目id，重置搜索条件和新增时需要使用
      projectList: [], // 项目列表
      searchForm: {}, // 搜索条件
      dateRange: [], // 搜索条件-起止日期
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 6,
        searchLabelWidth: 100,
        labelWidth: 100,
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            // search: true,
            // searchClearable: false,
          },
          {
            label: '圈子发布方',
            prop: 'userType',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=social_circle_user_type',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
          },
          {
            label: '发布人',
            prop: 'publisherName',
          },
          {
            label: '所属板块',
            prop: 'plateType',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=social_circle_plate_type',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
          },
          {
            label: '圈子内容',
            prop: 'content',
            overHidden: true,
          },
          {
            label: '发布时间',
            prop: 'publishTime',
          },
          {
            label: '发布状态',
            prop: 'publishStatus',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=social_circle_publish_status',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
          },
          {
            label: '显示状态',
            prop: 'showFlag',
            slot: true,
            search: true,
            type: 'select',
            dicData: [
              {
                dictValue: '显示',
                dictKey: 1,
              },
              {
                dictValue: '不显示',
                dictKey: 0,
              },
            ],
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '发布时间',
            prop: 'dateRange',
            hide: true,
            display: false,
            showColumn: false,
            search: true,
            searchslot: true,
            searchSpan: 12,
          },
          {
            label: '内容关键词',
            prop: '_content',
            search: true,
            hide: true,
            display: false,
            showColumn: false,
            maxlength: 50,
            showWordLimit: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.socialCircle_circleManage_add, false),
        delBtn: this.vaildData(this.permission.socialCircle_circleManage_del, false),
        editBtn: this.vaildData(this.permission.socialCircle_circleManage_edit, false),
        viewBtn: this.vaildData(this.permission.socialCircle_circleManage_view, false),
        releaseBtn: this.vaildData(this.permission.socialCircle_circleManage_release, false),
        visibleBtn: this.vaildData(this.permission.socialCircle_circleManage_visible, false),
        hiddenBtn: this.vaildData(this.permission.socialCircle_circleManage_hidden, false),
        replyBtn: this.vaildData(this.permission.socialCircle_circleManage_reply, false),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 390; // 表格区域初始化高度
      const searchH = 110; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      this.oldProjectId = this.searchForm.projectId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.dateRange = [];
      this.searchForm = {
        projectId: this.oldProjectId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.searchForm.content = this.searchForm._content;
      this.dealDateRange();
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.timeStart = this.dayjs(this.dateRange[0]).format('YYYY-MM-DD');
        this.searchForm.timeEnd = this.dayjs(this.dateRange[1]).format('YYYY-MM-DD');
      } else {
        this.searchForm.timeStart = '';
        this.searchForm.timeEnd = '';
        this.dateRange = [];
      }
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        view: '查看',
        add: '新增',
        edit: '编辑',
        reply: '回复',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      if (type == 'view') {
        this.needCloseConfirm = false;
      } else {
        this.needCloseConfirm = true;
      }
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 关闭表单弹框 */
    closeDialog() {
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 操作确认弹框 */
    showConfirm(type, row) {
      let msgs = {
        del: '删除',
        release: '发布',
        visible: '显示',
        hidden: '隐藏',
      };
      this.$confirm(`确定将选择数据${msgs[type]}?`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          switch (type) {
            case 'del':
              return delApi({
                ids: row.id,
              });
            case 'release':
              return releaseApi({
                id: row.id,
              });
            case 'visible':
            case 'hidden':
              return visibleApi({
                id: row.id,
                showFlag: type == 'visible' ? 1 : 0,
              });
          }
        })
        .then(() => {
          this.loadData();
          this.$message.success('操作成功!');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
